// extracted by mini-css-extract-plugin
export default {"wrapper":"K8fWL__wrapper","header":"ZiCIW__header"};